import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

const Header = ({ institute, fromDate, toDate }) => (
  <View style={styles.header}>
    <View style={styles.logoContainer}>
      {institute?.instituteLogo && (
        <Image
          src={institute.instituteLogo}
          style={styles.logo}
        />
      )}
    </View>

    <View style={styles.titleContainer}>
      <Text style={styles.schoolName}>
        {institute?.instituteName}
      </Text>

      <Text style={styles.address}>
        {institute?.instituteAddress}
      </Text>

      <Text style={styles.contact}>
        Contact: {institute?.instituteMobileNo} | Email: {institute?.instituteEmail}
      </Text>

      <Text style={styles.title}>
        Discount Report
      </Text>


    </View>
  </View>
);

const styles = StyleSheet.create({

  page: {
    padding: 20,
    fontSize: 10
  },


  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 18,
    borderBottomWidth: 1,
    borderBottomColor: "#cfcfcf",
    paddingBottom: 10,
  },

  logoContainer: {
    width: 80,
    justifyContent: "center",
    alignItems: "center",
  },

  titleContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 80, // balances the logo width
  },
  logo: {
    width: 65,
    height: 65,
  },

  schoolName: {
    fontSize: 18,
    fontWeight: "bold",
  },

  address: {
    fontSize: 9,
    marginTop: 2,
  },
  head: {
    backgroundColor: "#eeeeee",
    fontWeight: "bold",
  },

  table: {
    display: "table",
    width: "100%",
    marginTop: 5,
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  },
  contact: {
    fontSize: 9,
    marginTop: 2,
  },

  title: {
    marginTop: 8,
    fontSize: 14,
    fontWeight: "bold",
  },

  subTitle: {
    marginTop: 4,
    fontSize: 10,
  },


  row: {
    flexDirection: "row",
    alignItems: "center",
  },



  cell: {
    padding: 4,
    fontSize: 10,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  }

});
const DiscountReport = ({
  report,
  fromDate,
  toDate
}) => {

  const institute = report.institute;
  const students = report.data || [];
  const installmentColumns = report.installmentColumns || [];

  const grandTotals = {};
  let overallTotal = 0;

  installmentColumns.forEach(column => {
    grandTotals[column] = 0;
  });

  students.forEach(student => {

    installmentColumns.forEach(column => {

      grandTotals[column] += Number(
        student.installments?.[column] || 0
      );

    });

    overallTotal += Number(student.totalDiscount || 0);

  });



  return (

    <Document>

      <Page
        size="A4"
        style={styles.page}
      >

        <Header
          institute={institute}
          fromDate={fromDate}
          toDate={toDate}
        />


        <View style={styles.table}>

          <View style={[styles.row, styles.head]}>

            <Text style={[styles.cell, { flex: 0.5 }]}>#</Text>

            <Text style={[styles.cell, { flex: 2.5 }]}>
              Student
            </Text>

            <Text style={[styles.cell, { flex: 1 }]}>
              Class-Sec
            </Text>

            {installmentColumns.map(column => (
              <Text
                key={column}
                style={[styles.cell, { flex: 1 }]}
              >
                {column}
              </Text>
            ))}

            <Text style={[styles.cell, { flex: 1 }]}>
              Total
            </Text>

          </View>

          {students.map((student, index) => (

            <View
              key={index}
              style={styles.row}
            >

              <Text style={[styles.cell, { flex: 0.5 }]}>
                {index + 1}
              </Text>

              <Text style={[styles.cell, { flex: 2.5 }]}>
                {student.studentName}
              </Text>

              <Text style={[styles.cell, { flex: 1 }]}>
                {student.className}
              </Text>

              {installmentColumns.map(column => (
                <Text
                  key={column}
                  style={[styles.cell, { flex: 1 }]}
                >
                  {student.installments?.[column] ?? 0}
                </Text>
              ))}

              <Text style={[styles.cell, { flex: 1 }]}>
                {student.totalDiscount}
              </Text>

            </View>

          ))}

          <View style={[styles.row, styles.head]}>

            <Text
              style={[
                styles.cell,
                {
                  flex: 4.31,
                  fontWeight: "bold"
                }
              ]}
            >
              Grand Total
            </Text>

            {installmentColumns.map(column => (
              <Text
                key={column}
                style={[
                  styles.cell,
                  {
                    flex: 1,
                    fontWeight: "bold"
                  }
                ]}
              >
                {grandTotals[column]}
              </Text>
            ))}

            <Text
              style={[
                styles.cell,
                {
                  flex: 1,
                  fontWeight: "bold"
                }
              ]}
            >
              {overallTotal}
            </Text>

          </View>

        </View>

      </Page>

    </Document>

  );

};

export default DiscountReport;